export const CAVEATS = [
  'In IE, scrolling performance is not better. I\'m reluctant to improve it because I don\'t believe there is no programmer who edits code in IE anymore.',
  'The editor is not intended to run gigantic code. You will notice the input latency around 20,000 lines.',
];